<template>
  <div class="m-paginate">
    <div v-if="useUrl">
      <VButton
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showPrevious"
        :transition="true"
        :action="clickPrev"
        :to="prevUrl"
        data-test="page-previous">{{ previous }}</VButton>
      <div class="m-paginate__indicator">
        <span v-if="loading">
          Loading
        </span>
        <span v-else>
          {{ currentPageInteger }} of {{ lastPageInteger }}
        </span>
      </div>
      <VButton
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showNext"
        :transition="true"
        :action="clickNext"
        :to="nextUrl"
        data-test="page-next">{{ next }}</VButton>
    </div>
    <div v-else>
      <VButton
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showPrevious"
        :transition="true"
        :action="clickPrev"
        href="#"
        data-test="page-previous">{{ previous }}</VButton>
      <div class="m-paginate__indicator">
        <span v-if="loading">
          Loading
        </span>
        <span v-else>
          {{ currentPageInteger }} of {{ lastPageInteger }}
        </span>
      </div>
      <VButton
        type="outline-1"
        class="m-paginate__button"
        :disabled="loading || !showNext"
        :transition="true"
        :action="clickNext"
        href="#"
        data-test="page-next">{{ next }}</VButton>
    </div>
  </div>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';

export default {
  name: 'VPaginate',
  introduction: 'Buttons for list pagination.',
  components: {
    VButton,
  },
  props: {
    last: {
      type: Number,
      required: true,
      note: 'Total number of pages in the results.',
    },
    current: {
      type: Number,
      required: true,
      note: 'Current page displayed',
    },
    storeAction: {
      type: String,
      required: true,
      note: 'The VueX store method to call upon next or previous page.',
    },
    value: {
      type: [Object, String],
      note: 'Unused, needs removal.',
    },
    useUrl: {
      type: Boolean,
      required: false,
      note: 'If true the buttons change the page to the current page number +/- 1.',
    },
    previous: {
      type: String,
      required: false,
      default: 'Previous',
      note: 'Governs what text appears on the button for navigating backwards',
    },
    next: {
      type: String,
      required: false,
      default: 'Next',
      note: 'Governs what text appears on the button for navigating forwards',
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    loading() {
      if (!this.last || !this.current) return true;
      return false;
    },
    currentPageInteger() {
      return Number.parseInt(this.current, 10);
    },
    lastPageInteger() {
      if (!this.last >= 1) {
        return 'unknown';
      }

      return Number.parseInt(this.last, 10);
    },
    showPrevious() {
      if (this.currentPageInteger <= 1) {
        return false;
      }

      return true;
    },
    showNext() {
      if (this.currentPageInteger >= this.lastPageInteger) {
        return false;
      }

      return true;
    },
    nextUrl() {
      const pageNum = this.current - 1;
      if (pageNum >= this.last) return this.last.toString();

      return (this.current + 1).toString();
    },
    prevUrl() {
      const pageNum = this.current - 1;
      if (pageNum < 1) return '1';
      return pageNum.toString();
    },
  },
  methods: {
    clickNext() {
      let page = this.currentPageInteger;

      if (!this.useUrl) page += 1;

      // This can only be run in apps with store.
      this.$store.dispatch(this.storeAction, { page });
      this.$bus.$emit('scrollTo', { amount: 0 });
    },
    clickPrev() {
      let page = this.currentPageInteger;

      if (!this.useUrl) page -= 1;

      this.$store.dispatch(this.storeAction, { page });
      this.$bus.$emit('scrollTo', { amount: 0 });
    },
  },
  watch: {
    current: {
      handler() {
        if (!this.loading && this.currentPageInteger > this.lastPageInteger) {
          if (this.useUrl === true) {
            // This can only be run in apps with vue router.
            this.$router.replace(this.last.toString());
            this.$bus.$emit('renderGlobalMessage', ({ message: 'Page beyond limit, showing last page instead.', icon: 'exclamation-triangle', type: 'warning' }));
          }

          this.$store.dispatch(this.storeAction, { page: this.last });
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.m-paginate {
  margin-top: var(--spacing-base);
  text-align: center;
}

.m-paginate__button {
  float: none !important;
  display: inline-block !important;
}

.m-paginate__indicator {
  display: inline-block !important;
  padding: 0 var(--spacing-base);
}
</style>
